import React from 'react';
import ProposalImage from './ProposalImage';
import plantImage from '../assets/proposalImages/pollution_free_process.png';

export default function QuotationFromToPage({ company = {}, client = {}, letter = {} }) {
  const companyName = (client.company || '').trim();
  const address = (client.address || '').trim();
  const location = (client.location || '').trim();
  const email = (client.email || '').trim();
  const phone = (client.phone || '').trim();
  const kindAttn = (client.kindAttn || '').trim();
  const cpEmail = (client.concernedPersonEmail || '').trim();
  const cpMobile = (client.concernedPersonMobile || '').trim();
  const cpDesignation = (client.concernedPersonDesignation || '').trim();

  const addressLines = [address, location].filter(Boolean);
  const showCpPhone = Boolean(cpMobile) && cpMobile !== phone;
  const showConcernedBlock =
    Boolean(kindAttn || cpEmail || cpDesignation || showCpPhone);

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-no-break" style={{ marginBottom: 18 }}>
          <h2 className="quotation-heading-with-divider" style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
            Proposal Details
          </h2>
          <div className="quotation-yellow-divider" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginBottom: 20 }}>
          <div>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 14, color: '#000814', margin: '0 0 10px 0', textTransform: 'uppercase' }}>
              FROM:
            </p>
            <div style={{ borderLeft: '3px solid #ffbe0b', paddingLeft: 12 }}>
              <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, margin: '0 0 8px 0', color: '#000814', fontSize: 15 }}>
                {company.name || 'VALUE ADDED COATING SOLUTION PVT. LTD.'}
              </p>
              <p style={{ fontSize: 12, color: '#666', margin: '4px 0', lineHeight: 1.6 }}>
                Head Office: {company.headOffice || '515, Devika Tower, Chandra Nagar, Ghaziabad, U.P.'}<br />
                Branch Office: {company.branchOffice || '24&25, Naryani Market, Khandsa Road, Gurgaon, Haryana'}<br />
                Works: {company.works || 'K-288, Site-V, Surajpur Industrial Area, Kasna, Greater Noida (U.P)'}
              </p>
              <p style={{ fontSize: 12, color: '#000814', margin: '8px 0 0 0' }}>
                <strong>Website:</strong> {company.website || 'www.coating-solution.com, www.optifinish.in'}
              </p>
              <p style={{ fontSize: 12, color: '#000814', margin: '4px 0' }}>
                <strong>E-mail:</strong> {company.email || 'info@coating-solution.com'}
              </p>
            </div>
          </div>

          <div>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 14, color: '#000814', margin: '0 0 10px 0', textTransform: 'uppercase' }}>
              TO:
            </p>
            <div style={{ borderLeft: '3px solid #ffbe0b', paddingLeft: 12 }}>
              {companyName ? (
                <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, margin: '0 0 8px 0', color: '#000814', fontSize: 15 }}>
                  {companyName}
                </p>
              ) : (
                <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, margin: '0 0 8px 0', color: '#000814', fontSize: 15 }}>
                  —
                </p>
              )}
              {addressLines.length > 0 ? (
                <p style={{ fontSize: 12, color: '#666', margin: '4px 0', lineHeight: 1.6 }}>
                  {addressLines.map((line, i) => (
                    <React.Fragment key={i}>
                      {i > 0 ? <br /> : null}
                      {line}
                    </React.Fragment>
                  ))}
                </p>
              ) : null}
              {email ? (
                <p style={{ fontSize: 12, color: '#000814', margin: '6px 0 0 0' }}>
                  <strong>E-mail:</strong> {email}
                </p>
              ) : null}
              {phone ? (
                <p style={{ fontSize: 12, color: '#000814', margin: '4px 0 0 0' }}>
                  <strong>Phone:</strong> {phone}
                </p>
              ) : null}

              {showConcernedBlock ? (
                <>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: 12, color: '#000814', margin: '12px 0 6px 0' }}>
                    Concerned person
                  </p>
                  {kindAttn ? (
                    <p style={{ fontSize: 12, color: '#666', margin: '2px 0' }}>
                      <strong>Name:</strong> {kindAttn}
                    </p>
                  ) : null}
                  {cpEmail ? (
                    <p style={{ fontSize: 12, color: '#666', margin: '2px 0' }}>
                      <strong>E-mail:</strong> {cpEmail}
                    </p>
                  ) : null}
                  {showCpPhone ? (
                    <p style={{ fontSize: 12, color: '#666', margin: '2px 0' }}>
                      <strong>Phone:</strong> {cpMobile}
                    </p>
                  ) : null}
                  {cpDesignation ? (
                    <p style={{ fontSize: 12, color: '#666', margin: '2px 0' }}>
                      <strong>Designation:</strong> {cpDesignation}
                    </p>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div style={{ height: 1, background: '#ddd', margin: '20px 0' }} />

        <div style={{ marginBottom: 12 }}>
          <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: 14, color: '#000814', margin: '0 0 8px 0' }}>
            <strong>Subject:</strong> {letter.subject || 'Your Requirement of selected products'}
          </p>
          <p style={{ fontSize: 12, color: '#333', margin: '0 0 4px 0' }}>
            <strong>Reference:</strong> {letter.reference || 'As per discussion held with you.'}
          </p>
        </div>

        <div style={{ marginTop: 12, flex: 1, minHeight: 0, overflow: 'auto' }}>
          {(letter.body || []).map((para, i) => (
            <p key={i} style={{ fontSize: 12, color: '#333', lineHeight: 1.6, margin: '0 0 8px 0' }}>
              {para}
            </p>
          ))}
        </div>

        <ProposalImage src={plantImage} imgStyle={{ borderRadius: 22 }} />
      </div>
    </div>
  );
}
